import React from 'react'

const CustomInputField = ({label, onChange, placeholder, name, type, value, error,onBlur, touched, readOnly=false }) => {
  return (
    <div className="form-group">
        <label className="form-label">
          {label}
        </label>
        <input
          required
          className={`form-control ${touched && error ? 'is-invalid' : ''}`}
          type={type ? type: "text"}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          readOnly={readOnly}
        />
        {touched && error && (
        <div class="invalid-feedback">
          {error}
        </div>
        )}
    </div>
  )
}

export default CustomInputField;